import { RadioButton } from "@etframework/ui.components";
import { useTranslation, Trans } from "react-i18next";
import { PreferenceComponent } from "../PreferenceComponent";
import { useSystemPreferences } from "../../../data/queries/systemPreferencesQueries";
import Enums from "../../../types/enums";

export const GeneralNotificationsContent = ({
  tasksSummaryEmailEnabledRef,
  taskDueSoonEmailEnabledRef,
  addedToTaskBoardEmailEnabledRef,
  userNotificationData,
  newCommentsAddedEmailEnabledRef,
  onChange,
}) => {
  const { t } = useTranslation(["Preferences"]);

  const { data: SystemPreferences, isPending } = useSystemPreferences();

  if (isPending) return null;

  return (
    <>
      <div className="m-4 d-flex justify-content-between">
        <div className="fw-600 col-3">
          {t("NotificationPreferences.GeneralNotifications")}
        </div>
        <div className="notification-content col-9">
          <PreferenceComponent
            ref={tasksSummaryEmailEnabledRef}
            title={t("NotificationPreferences.TasksSummary")}
            checkedValue={userNotificationData?.TaskSummaryEmailEnabled}
            titleBold={true}
            change={onChange}
          />

          <div className="d-flex justify-content-start gap-5 notification-content my-3 mx-5 bg-et-lightest-gray">
            <div className="m-4">
              <div className="fw-600">
                {t("NotificationPreferences.ReceiveEmails")}
              </div>
              <div>
                <div className="py-1">
                  <RadioButton
                    id={"weekly"}
                    label={t("Weekly")}
                    checked={
                      userNotificationData?.EmailFrequency ==
                      Enums.EmailFrequency.Weekly
                    }
                    value={"emailFrequencyWeekly"}
                    change={onChange}
                    name={"EmailFrequency"}
                  />
                </div>
                <div className="py-1">
                  <RadioButton
                    id={"monthly"}
                    label={t("Monthly")}
                    checked={
                      userNotificationData?.EmailFrequency ==
                      Enums.EmailFrequency.Monthly
                    }
                    value={"emailFrequencyMonthly"}
                    change={onChange}
                    name={"EmailFrequency"}
                  />
                </div>
              </div>
            </div>

            <div className="m-4">
              <div className="fw-600">
                {t("NotificationPreferences.NotifyMeAbout")}
              </div>
              <div>
                <div className="py-1">
                  <RadioButton
                    id={"allTasks"}
                    label={t("AllTasks")}
                    checked={
                      userNotificationData?.NotifyMeAbout ==
                      Enums.NotifyMeAbout.AllTasks
                    }
                    value={"notifyMeAboutAllTasks"}
                    change={onChange}
                    name={"NotifyMeAbout"}
                  />
                </div>
                <div className="py-1">
                  <RadioButton
                    id={"myTasks"}
                    label={t("MyTasks")}
                    checked={
                      userNotificationData?.NotifyMeAbout ==
                      Enums.NotifyMeAbout.MyTasks
                    }
                    value={"notifyMeAboutMyTasks"}
                    change={onChange}
                    name={"NotifyMeAbout"}
                  />
                </div>
                <div className="py-1">
                  <RadioButton
                    id={"tasksRelatedToMe"}
                    label={t("TasksRelatedToMe")}
                    checked={
                      userNotificationData?.NotifyMeAbout ==
                      Enums.NotifyMeAbout.TasksRelatedToMe
                    }
                    value={"notifyMeAboutTasksRelatedToMe"}
                    change={onChange}
                    name={"NotifyMeAbout"}
                  />
                </div>
              </div>
            </div>
          </div>

          <hr />
          <PreferenceComponent
            ref={taskDueSoonEmailEnabledRef}
            title={t("NotificationPreferences.Reminders")}
            checkedValue={userNotificationData?.TaskDueSoonEmailEnabled}
            titleBold={true}
            change={onChange}
          />
          <div className="notification-content my-3 mx-5 bg-et-lightest-gray">
            <div className="m-4">
              <div>
                <Trans components={{ b: <strong /> }}>
                  {t("NotificationPreferences.NotifyDaysPrior", {
                    days: SystemPreferences?.TaskApproachingDaysPrior,
                  })}
                </Trans>
              </div>
              <div>
                <div className="informative-banner p-2">
                  <div>
                    <i className="fa-regular fa-circle-info informative-banner-icon"></i>
                  </div>
                  <div className="ps-3">
                    <p className="informative-banner-message">
                      {t(
                        "NotificationPreferences.NotifyDaysPriorInformativeMsg"
                      )}
                    </p>
                  </div>
                </div>
              </div>
            </div>
          </div>

          <hr />
          <PreferenceComponent
            ref={newCommentsAddedEmailEnabledRef}
            title={t("NotificationPreferences.MentionedInAComment")}
            checkedValue={userNotificationData?.NewCommentsEmailEnabled}
            titleBold={true}
            change={onChange}
          />

          <hr />
          <PreferenceComponent
            ref={addedToTaskBoardEmailEnabledRef}
            title={t("NotificationPreferences.AddedToTaskBoard")}
            checkedValue={userNotificationData?.AddedToTaskBoardEmailEnabled}
            titleBold={true}
            change={onChange}
          />
        </div>
      </div>
    </>
  );
};
